import React from "react";
import {getCardIcon} from "../../../utils/utils"
import { useTranslation } from "react-i18next";

function PartnersCard(props) {

    const { t } = useTranslation()

    const {partners} = props

    return (
        <div className="analysisCard">
            <div style={{display:"flex"}}>
                <div 
                    className={["blueText", "subtitleSize", "bold"].join(" ")}
                    style={{margin:"auto 0px"}}
                >
                    {t("partners")}
                </div>
                <div style={{margin:"auto 10px"}}>
                    {getCardIcon(partners.flag)}
                </div>
            </div>
            {partners.description == null ? null :
            <div 
                className={["normalText", "normalMediumSize", "internalCardContainer"].join(" ")}
            >
                {partners.description}
            </div>
            }
        </div>
        );
}


export default PartnersCard
